<template>
  <div class="app-container" id="app">
    <preloader />
    <a v-longpress="onLogoLongpress" @click.prevent="() => {}" @mousedown="onLogoPress" @mouseup="onLogoRelease" href="/" class="site-logo" data-dont-hide-panels>
      <img :src="showAnimatedLogo ? logoAnimated : logo" alt="Logo">
    </a>
    <event-and-contact-panel />
    <div ref="scrollContainer" class="scroll-container" v-bar="{ overrideFloatingScrollbar: true }">
      <div @scroll="onScroll">
        <main class="container">
          <site-header ref="header" />
          <transition name="route-fade" mode="out-in">
            <router-view :key="$route.params.slug || $route.path"/>
          </transition>
        </main>
      </div>
    </div>
    <archive-panel />
    <panel-controls />
    <panel-close-hotspots />
  </div>
</template>

<script>
import EventAndContactPanel from './panels/EventsAndContactPanel.vue'
import ArchivePanel from './panels/ArchivePanel.vue'
import Header from './partials/Header.vue'
import PanelControls from './partials/PanelControls.vue'
import PanelCloseHotspots from './partials/PanelCloseHotspots.vue'
import Preloader from './partials/Preloader.vue'
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  data() {
    return {
      showAnimatedLogo: false,
      logoPressedAt: null
    }
  },
  computed: {
    ...mapState({
      logo: state => state.theme.logo,
      logoAnimated: state => state.theme.logoAnimated,
      title: state => state.theme.title,
      filmContentVisible: state => state.filmContentVisible
    })
  },
  components: {
    'event-and-contact-panel': EventAndContactPanel,
    'archive-panel': ArchivePanel,
    'site-header': Header,
    'panel-controls': PanelControls,
    'panel-close-hotspots': PanelCloseHotspots,
    'preloader': Preloader
  },
  metaInfo() {
    return {
      title: 'Loading...',
      titleTemplate: `%s | ${this.title}`
    }
  },
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'route/ROUTE_CHANGED') {
        setTimeout(() => {
          this.$refs.scrollContainer._vuebarState.el2.scrollTop = 0
        }, 250)
      }
    })
  },
  methods: {
    onScroll: _.throttle(function (e) {
      const current = e.target.scrollTop > 0
      if (this.filmContentVisible !== current)
        this.$store.commit('setFilmContentVisible', current)
    }, 300),
    onLogoPress: function (e) {
      this.logoPressedAt = performance.now()
    },
    onLogoRelease: function (e) {
      if (performance.now() - this.logoPressedAt < 500)
        this.$router.push('/')
    },
    onLogoLongpress: function (e) {
      return new Promise((resolve, reject) => {
        this.showAnimatedLogo = true
        setTimeout(() => {
          this.$store.commit('setPanelVisibleLeft', false)
          this.$store.commit('setPanelVisibleRight', false)
        }, 3400)
        setTimeout(() => {
          this.$refs.header.$emit('globalReset')
          this.$router.push('/')
        }, 3500)
        setTimeout(() => {
          this.showAnimatedLogo = false
          resolve()
        }, 3600)
      })
    }
  }
}
</script>
